@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.notificationdata

data class IncomingCallDto(
    val username: String,
    val password: String,
    val domain: String,
    val callId: String,
    val driverName: String
)